import { useTheme } from 'styled-components';
import { SignUpForm } from '../../components/user_management/signup-form';
import AuthenticationContext from '../../contexts/authentication.context';
import config from '../../utils/config';
import './user_management.css';

export function SignUp(props) {
	const theme = useTheme();

	return (
		<AuthenticationContext.Consumer>
			{(authProps: any) => (
				<div className="bg-overlay-dark">
					<div className="mx-auto form-container justify-content-center d-flex flex-column align-items-center py-3">
						<div className="m-4">
							<p
								style={{
									color: theme.TA_GREEN,
									fontSize: '2.625rem',
									fontWeight: 400,
									margin: '10px 0'
								}}
							>
								Hire Outstanding Software Engineers Now!
							</p>
							<div style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
								<p>Fill in the form and get matched with the top talents in town.</p>
								<p>We guarantee efficiency and speed of hiring</p>
							</div>
						</div>
						<div className="p-4 mt-0 my-md-5 ta-form-container">
							<SignUpForm
								signInUrl={config.URIs.sign_up_uri}
								callback={(token, profile) => {
									authProps.setAuthenticated(true, token, profile);
								}}
								{...props}
							/>
						</div>
					</div>
				</div>
			)}
		</AuthenticationContext.Consumer>
	);
}
